import { FaStethoscope } from "react-icons/fa";
import { BsHeartPulse } from "react-icons/bs";
import { RiToothLine } from "react-icons/ri";
import { LiaChalkboardTeacherSolid } from "react-icons/lia";
import { GiHypodermicTest } from "react-icons/gi";
import { MdOutlineBloodtype } from "react-icons/md";

export const SERVICES = [
    {
        icon: <FaStethoscope className="text-5xl main-color" />,
        title: "Consultation",
        description:
            "Providing on-demand expert advice tailored to your needs, helping you make informed decisions and achieve your goals efficiently, with no long-term commitments.",
    },
    {
        icon: <BsHeartPulse className="text-5xl main-color" />,
        title: "Perinatal",
        description:
            "We provide comprehensive support for expectant and new parents throughout the perinatal period.",
    },
    {
        icon: <GiHypodermicTest className="text-5xl main-color" />,
        title: "Immunisation",
        description:
            "We provide convenient, reliable, and professional immunization services tailored to individuals, families, or organizations.",
    },
    {
        icon: <RiToothLine className="text-5xl main-color" />,
        title: "Dental Services",
        description:
            "We offer on-demand dental care, from routine check-ups to advanced treatments, ensuring convenient, high-quality services for a healthy, bright smile.",
    },
    {
        icon: <LiaChalkboardTeacherSolid className="text-5xl main-color" />,
        title: "Counselling",
        description:
            "We offer personalized, confidential counseling to support your mental health and well-being with tailored guidance and strategies.",
    },
    {
        icon: <MdOutlineBloodtype className="text-5xl main-color" />,
        title: "Hiv/Aids Testing",
        description:
            "We provide confidential HIV/AIDS testing with accurate results and support for early detection and prevention.",
    },
];

export default function Services() {
    return (
        <div className="container pt-20 pb-16">
            <div className="max-w-xl mx-auto text-center">
                <h2 className="headings mb-4">
                    We Offer Different Services To Improve Your Health
                </h2>
                <p>
                    Transform your health with our expert services, tailored to boost
                    energy, reduce stress, and achieve your wellness goals. Your
                    well-being starts here!
                </p>
            </div>

            <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-10 mt-16 px-8">
                {SERVICES.map((s, i) => (
                    <div key={i} className="flex gap-6">
                        <div>{s.icon}</div>
                        <div>
                            <h6 className="md:text-xl mb-3 font-medium">{s.title}</h6>
                            <p className="text-sm md:text-base gray-color">{s.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
